import Hero from "../components/Hero";
import Services from "../components/Services";
import WhyGrid from "../components/WhyGrid";
import WhyVoltCore from "../components/WhyVoltCore";
import OurWork from "../components/OurWork";
import Reviews from "../components/Reviews";
import Referenzen from "../components/Referenzen";
import Contact from "../components/Contact";

export default function Home() {
  return (
    <main>
      <Hero />
      <Services />
      <WhyGrid />
      <WhyVoltCore />
      <OurWork />
      <Reviews />
      <Referenzen />
      <Contact />
    </main>
  );
}
